module.exports = __webpack_public_path__ + "../resources/img/ic_pause_dark.a9e777cd.svg";